import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";
import { CrmRedirect } from "./external-redirects/CrmRedirect";

export const RedirectRoutes: FunctionComponent = () => {
  return (
    <Routes>
      <Route path="/crm/*" element={<CrmRedirect />} />
    </Routes>
  );
};
